/** מזהי פריטי התפריט ב־`views-pages` שניתן לנהל להם נראות למשתמשי אפליקציה */
/** סדר כרונולוגי (1→6): לשיוך לנציג → למענה ראשוני → לאיש קשר → להמשך מענה → בהקפאה → הסתיימו */
export const DEFAULT_CHAT_SIDEBAR_VIEW_IDS = [
  'unassigned-chats',
  'newly-assigned',
  'awaiting-me',
  'waiting-customer',
  'my-chats-snoozed',
  'chats-completed',
] as const;

export type DefaultChatSidebarViewId = (typeof DEFAULT_CHAT_SIDEBAR_VIEW_IDS)[number];

export function isDefaultChatSidebarViewId(id: string | undefined): id is DefaultChatSidebarViewId {
  return !!id && (DEFAULT_CHAT_SIDEBAR_VIEW_IDS as readonly string[]).includes(id);
}

export const DEFAULT_CHAT_SIDEBAR_VIEW_TITLE_IDS: Record<DefaultChatSidebarViewId, string> = {
  'unassigned-chats': 'sidebar.nav.views.unassignedPendingAssign',
  'awaiting-me': 'sidebar.nav.views.awaitingReply',
  'newly-assigned': 'sidebar.nav.views.firstReply',
  'waiting-customer': 'sidebar.nav.views.awaitingCustomerShort',
  'my-chats-snoozed': 'sidebar.nav.views.reminderByDate',
  'chats-completed': 'sidebar.nav.views.completedArchive',
};

/** תצוגות «כל המשתמשים» — מקבילות לששת ברירת המחדל */
export const TEAM_CHAT_SIDEBAR_VIEW_IDS = [
  'team-unassigned-chats',
  'team-newly-assigned',
  'team-awaiting-me',
  'team-waiting-customer',
  'team-my-chats-snoozed',
  'team-chats-completed',
] as const;

export type TeamChatSidebarViewId = (typeof TEAM_CHAT_SIDEBAR_VIEW_IDS)[number];

export function isTeamChatSidebarViewId(id: string | undefined): id is TeamChatSidebarViewId {
  return !!id && (TEAM_CHAT_SIDEBAR_VIEW_IDS as readonly string[]).includes(id);
}

export function isAppChatSidebarConfigurableViewId(id: string | undefined): boolean {
  if (!id || id.startsWith('unified-')) return false;
  return isDefaultChatSidebarViewId(id) || isTeamChatSidebarViewId(id);
}
